import React from "react";
import { useParams } from "react-router-dom";
import CityLanding from "@/pages/CityLanding";
import SitterDetail from "@/pages/SitterDetail";
import { CITY_SLUGS } from "@/data/cityMeta";

// Dispatcher: /babysitters/{param}
// - If {param} is a known GTA city slug → render CityLanding
// - Otherwise → render SitterDetail (id or sitter slug)
export default function CityOrSitter() {
  const { id } = useParams();
  const isCity = CITY_SLUGS.includes((id || "").toLowerCase());
  if (isCity) return <CityLanding />;
  return <SitterDetail />;
}
